/**
 * schemas/config/rules.ts
 * The two org-level rules Settings exposes, plus the escalation window the API
 * stores but does not yet enforce.
 */
import { z } from 'zod';

/** The only values the "Count is overdue after" chips offer. */
export const STALE_DAYS = [3, 7, 14, 30] as const;
export type StaleDays = (typeof STALE_DAYS)[number];

export const rulesSchema = z.object({
  /**
   * Drives the Overview's "unreconciled assignments" figure and its label.
   * This is the ORG's definition of stale; the register's colour ramp is a
   * separate display concern (lib/status.ts `staleness`).
   */
  stale_days: z.number(),
  /** Sets the default state of the receipt field on the spend form. */
  receipt_required: z.boolean(),
  /** Stored, not yet enforced. Shown nowhere in the UI today. */
  escalate_hours: z.number(),
});
export type Rules = z.infer<typeof rulesSchema>;

export const rulesPatchSchema = z.object({
  stale_days: z.union([z.literal(3), z.literal(7), z.literal(14), z.literal(30)]).optional(),
  receipt_required: z.boolean().optional(),
  escalate_hours: z.number().int().positive().max(720).optional(),
});
export type RulesPatch = z.infer<typeof rulesPatchSchema>;
